export enum DialogDimensions {
  WIDTH_FIFTY = '50%',
  HEIGHT_FIFTY = '50%',
  WIDTH_EIGHTY = '80%',
  HEIGHT_EIGHTY = '80%',
  MAXWIDTH = '100vw',
  MAXHEIGHT = '100vh'
}